var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCacIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 70,
    viewBox: "0 0 76 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6043 8.19306C61.8149 3.86543 56.9527 1 51.421 1H33.268H24.2079H10.7441C16.9637 1 22.0054 6.043 22.0054 12.2626V64.1797H24.2079H33.268H67.095V40.3247",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6043 8.19306C61.8149 3.86543 56.9527 1 51.421 1H33.268H24.2079H10.7441C16.9637 1 22.0054 6.043 22.0054 12.2626V64.1797H24.2079H33.268H67.095V40.3247",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6041 8.19306C61.8146 3.86543 56.9524 1 51.4207 1H33.2677H24.2076H10.7439C16.9635 1 22.0052 6.043 22.0052 12.2626V64.1797H24.2076H33.2677H67.0948V40.3247",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3203 6.12048C14.8931 5.39463 14.1044 4.90723 13.2016 4.90723C11.8443 4.90723 10.745 6.0078 10.745 7.36387V69.0001H63.9383",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0641 12.1494V64.1792V66.5061H66.1823",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8855 19.4297C72.8855 20.377 71.473 21.1265 71.2398 22.0004C70.9988 22.9044 71.8399 24.2579 71.3813 25.0492C70.9162 25.8524 69.3191 25.7974 68.6679 26.4485C68.0167 27.0997 68.0717 28.6969 67.2686 29.162C66.4772 29.6206 65.1238 28.7781 64.2197 29.0205C63.3458 29.2537 62.5964 30.6661 61.6491 30.6661C60.7018 30.6661 59.9524 29.2537 59.0785 29.0205C58.1744 28.7794 56.821 29.6206 56.0296 29.162C55.2264 28.6969 55.2815 27.0997 54.6303 26.4485C53.9791 25.7974 52.382 25.8524 51.9168 25.0492C51.4583 24.2579 52.3007 22.9044 52.0583 22.0004C51.8251 21.1265 50.4127 20.377 50.4127 19.4297C50.4127 18.4824 51.8251 17.733 52.0583 16.8591C52.2994 15.955 51.4583 14.6016 51.9168 13.8102C52.382 13.0071 53.9791 13.0621 54.6303 12.4109C55.2815 11.7598 55.2264 10.1626 56.0296 9.69748C56.821 9.23891 58.1744 10.0814 59.0785 9.83898C59.9524 9.60577 60.7018 8.19336 61.6491 8.19336C62.5964 8.19336 63.3458 9.60577 64.2197 9.83898C65.1238 10.0801 66.4772 9.23891 67.2686 9.69748C68.0717 10.1626 68.0167 11.7598 68.6679 12.4109C69.3191 13.0621 70.9162 13.0071 71.3813 13.8102C71.8399 14.6016 70.9974 15.955 71.2398 16.8591C71.473 17.733 72.8855 18.4824 72.8855 19.4297Z",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2971 27.9551L52.1028 39.0984L55.5146 37.0715L58.0289 39.9003L60.4003 30.8808",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0408 27.9551L72.2351 39.0984L68.8233 37.0715L66.309 39.9003L63.9375 30.8808",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6499 27.9554C66.3585 27.9554 70.1755 24.1384 70.1755 19.4298C70.1755 14.7213 66.3585 10.9043 61.6499 10.9043C56.9414 10.9043 53.1244 14.7213 53.1244 19.4298C53.1244 24.1384 56.9414 27.9554 61.6499 27.9554Z",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5409 20.4609H44.6553",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5409 27.9551H49.6419",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5409 36.4189H50.4123",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5409 46.8916H61.65",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5409 56.5332H63.9376",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9886 8.30566C34.2267 8.30566 35.1465 8.92408 35.5435 9.98798H34.8923C34.5831 9.25033 33.9319 8.79044 32.9873 8.79044C31.7727 8.79044 30.8451 9.68663 30.8451 11.1397C30.8451 12.5835 31.774 13.481 32.9873 13.481C33.9319 13.481 34.5818 13.0211 34.8923 12.2992H35.5435C35.1465 13.346 34.2267 13.9658 32.9886 13.9658C31.4491 13.9658 30.2751 12.8075 30.2751 11.141C30.2751 9.47175 31.4491 8.30566 32.9886 8.30566Z",
    fill: "#005555"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.86 12.5981H37.3366L36.8531 13.9148H36.2661L38.2891 8.43945H38.9167L40.9318 13.9148H40.3448L39.86 12.5981ZM38.5983 9.13911L37.503 12.1382H39.6923L38.5983 9.13911Z",
    fill: "#005555"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2788 8.30566C45.5169 8.30566 46.4367 8.92408 46.8337 9.98798H46.1825C45.8733 9.25033 45.2221 8.79044 44.2774 8.79044C43.0629 8.79044 42.1353 9.68663 42.1353 11.1397C42.1353 12.5835 43.0642 13.481 44.2774 13.481C45.2221 13.481 45.872 13.0211 46.1825 12.2992H46.8337C46.4367 13.346 45.5169 13.9658 44.2788 13.9658C42.7393 13.9658 41.5653 12.8075 41.5653 11.141C41.5653 9.47175 42.7393 8.30566 44.2788 8.30566Z",
    fill: "#005555"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42578 2.37207V4.11596",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63179 4.85449H8.17615",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77852 4.85449H5.32288",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42578 5.7002V7.44409",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8335 61.6426V63.3865",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0382 64.125H73.5839",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1862 64.125H70.7306",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8335 64.9707V66.7146",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8335 5.9043V7.6495",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0382 8.3877H73.5839",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1862 8.3877H70.7306",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8335 9.23242V10.9776",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10291 46.0371V47.7823",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30761 48.5195H3.85327",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45564 48.5195H1",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10291 49.3652V51.1104",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.3657,
    cy: 19.7002,
    r: 8.5,
    fill: "#F8B400",
    fillOpacity: 0.37
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCacIcon);
export default __webpack_public_path__ + "static/media/cacIcon.c110298e3dbbff1761e6986d26f6de29.svg";
export { ForwardRef as ReactComponent };